<!-- location -->
<template>

</template>
<script>

    export default {
        name: 'supper',

        data() { //默认数据
            return {}
        },
        created() { //视图加载前执行
            let _this = this;

        },
        mounted() { //视图加载完成执行
            let _this = this;
            _this.navigationTo('/goods/show', {goods_id: _this.$route.query.goods_id});
        },
        methods: { //页面方法

        },
        destroyed() {
            let _this = this;
            //切记页面销毁需要销毁
        }
    }
</script>
<style lang="scss">
</style>
